import "core-js/modules/es.array.iterator.js";
import { countriesI18n } from "./countries-i18n";
export const checkCountryCode = code => {
  const countryCode = code.toUpperCase();
  if (countriesI18n.isValid(countryCode)) return countryCode;
  return null;
};
export const getCountryFromLang = lang => {
  const [language, country] = lang.split('-');
  if (country) return checkCountryCode(country);
  if (language) return checkCountryCode(language);
  return null;
};
export const getBrowserLangCountry = () => {
  const lang = navigator.language;
  if (lang) {
    var _navigator$languages;
    const countryCode = getCountryFromLang(lang);
    if (countryCode) return countryCode;
    const allLangs = (_navigator$languages = navigator.languages) !== null && _navigator$languages !== void 0 ? _navigator$languages : [];
    const findedFullyLang = allLangs.find(l => l.startsWith(`${lang}-`));
    if (findedFullyLang) return getCountryFromLang(findedFullyLang);
  }
  return null;
};